var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":require(("@/assets/images/print_preview/" + (this.campaign.package.printSize) + ".jpg"))}})])}
var staticRenderFns = []

export { render, staticRenderFns }